"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.essDispatchesFactory = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const authored_evidence_1 = require("../../../composite/evidence/authored-evidence/authored-evidence");
const evidence_1 = require("../../../composite/evidence/evidence");
const dispatches_fields_1 = require("./dispatches-fields");
const dispatches_columns_1 = require("./dispatches-columns");
const lodash_1 = require("lodash");
const dispatches_detail_toolbar_1 = require("./dispatches-detail-toolbar");
function essDispatchesFactory(url, reportTag) {
    return function Dispatches() {
        const intl = react_intl_1.useIntl();
        const evidence = authored_evidence_1.useAuthoredEvidence({
            identifier: 'ESS_DISPATCHES',
            apiProps: {
                url,
            },
            tableProps: {
                columns: dispatches_columns_1.useColumns(),
                tableName: intl.formatMessage({
                    id: 'ESS_DISPATCHES_TABLE_TITLE',
                    defaultMessage: 'Vypravení',
                }),
                reportTag,
            },
            detailProps: {
                FieldsComponent: dispatches_fields_1.DispatchesFields,
                toolbarProps: {
                    after: react_1.default.createElement(dispatches_detail_toolbar_1.DispatchToolbar, { url: url }),
                    showButton: lodash_1.stubFalse,
                },
            },
        });
        return react_1.default.createElement(evidence_1.Evidence, Object.assign({}, evidence));
    };
}
exports.essDispatchesFactory = essDispatchesFactory;
//# sourceMappingURL=dispatches.js.map